// ============================================================
// Braval - New Lot Page
// ============================================================

import React, { useState, useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { apiFetch } from '../api';
import { Header } from '../App';
import LotForm from './LotForm';

export default function NewLotPage() {
    const navigate = useNavigate();
    const [searchParams] = useSearchParams();
    const preselectedProjectId = searchParams.get('projectId');

    const [initialValues] = useState(
        preselectedProjectId ? { project_id: parseInt(preselectedProjectId) } : {}
    );
    const [projects, setProjects] = useState([]);
    const [loading, setLoading] = useState(true);
    const [loadError, setLoadError] = useState(null);
    const [isSaving, setIsSaving] = useState(false);
    const [saveError, setSaveError] = useState(null);

    useEffect(() => {
        const fetchProjects = async () => {
            try {
                const res = await apiFetch('/api/projects');
                const data = await res.json();
                setProjects(Array.isArray(data) ? data : []);
            } catch (err) {
                setLoadError('Could not load projects.');
            } finally {
                setLoading(false);
            }
        };

        fetchProjects();
    }, []);

    const handleSave = async (formData) => {
        setIsSaving(true);
        setSaveError(null);
        try {
            const res = await apiFetch('/api/lots', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(formData),
            });
            if (!res.ok) {
                const err = await res.json();
                setSaveError(err.error || 'Failed to create lot.');
                return;
            }
            const { lot_id } = await res.json();
            navigate(`/lots/${lot_id}`);
        } catch (err) {
            setSaveError('Could not reach the API.');
        } finally {
            setIsSaving(false);
        }
    };

    return (
        <div className="app-layout">
            <Header />
            <main className="lot-form-page">
                {loading && (
                    <div className="results-status">Loading...</div>
                )}
                {loadError && (
                    <div className="results-status results-error">{loadError}</div>
                )}
                {!loading && !loadError && (
                    <LotForm
                        pageTitle="New Lot"
                        initialValues={initialValues}
                        projects={projects}
                        onSave={handleSave}
                        isSaving={isSaving}
                        saveError={saveError}
                    />
                )}
            </main>
        </div>
    );
}
